<div class="page">
  <div class="content">
    <div class="logo">Zip-Utils</div>
    <p class="title">404. <span>That’s an error.</span></p>
    <p class="desc">The requested URL was not found on this server.</p>
    <button routerLink="/">Take me back</button>
  </div>

  <div class="illustration">
    <!-- Simple Google-like robot SVG -->
    <svg width="160" height="200" viewBox="0 0 160 200" fill="none">
      <rect
        x="40"
        y="40"
        width="80"
        height="80"
        rx="4"
        stroke="#1a73e8"
        stroke-width="2"
      />
      <circle cx="65" cy="70" r="4" fill="#1a73e8" />
      <circle cx="95" cy="70" r="4" fill="#1a73e8" />
      <line
        x1="60"
        y1="95"
        x2="100"
        y2="95"
        stroke="#1a73e8"
        stroke-width="2"
      />

      <rect
        x="55"
        y="120"
        width="50"
        height="40"
        stroke="#1a73e8"
        stroke-width="2"
      />
      <line x1="80" y1="20" x2="80" y2="40" stroke="#1a73e8" stroke-width="2" />
      <circle cx="80" cy="18" r="4" fill="#1a73e8" />
    </svg>
  </div>
</div>
